import { render, staticRenderFns } from "./TestingStatistics.vue?vue&type=template&id=4be6272a&scoped=true"
import script from "./TestingStatistics.vue?vue&type=script&lang=js"
export * from "./TestingStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6272a",
  null
  
)

export default component.exports